import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-style-one',
  templateUrl: './features-style-one.component.html',
  styleUrls: ['./features-style-one.component.scss']
})
export class FeaturesStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
